<template>
  <v-dialog
    v-model="dialog"
    :overlay="false"
    max-width="300px"
    transition="dialog-transition"
  >
    <template #activator="{on}">
      <v-btn v-on="on" icon dark>
        <v-icon>fas fa-pen</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="warning mb-3">Update Branch</v-card-title>
      <v-card-text>
        <v-form ref="BranchForm" v-model="valid">
          <!-- Branch information Row -->
          <v-text-field
            outlined
            solo
            validate-on-blur
            :rules="[v => !!v || 'Branch Name is required', checkBranchName]"
            label="Branch Name"
            v-model.trim="BranchInfo.BranchName"
            :append-icon="NameIcon"
            color="success"
            required
          >
          </v-text-field>
          <v-text-field
            outlined
            solo
            :rules="[v => !!v || 'Branch phone is require']"
            label="Branch Phone"
            v-model.number="BranchInfo.BranchPhone"
            required
            type="number"
          ></v-text-field>
          <v-text-field
            outlined
            solo
            :rules="[v => !!v || 'Manager Name is require']"
            label="Manager Full Name"
            v-model.trim="BranchInfo.BranchAdmin"
            required
          >
          </v-text-field>
        </v-form>

        <p class="font-weight-bold text-center" v-if="msgError">
          {{ msgError }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid"
          color="success"
          width="200"
          :loading="clicked"
          @click="OnSaveBranch"
        >
          Update
          <v-icon right>fas fa-content</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// import { mapGetters } from "vuex";
export default {
  props: {
    Branch: { type: Object, required: true },
  },
  data: () => ({
    msgError: "",
    clicked: false,
    dialog: false,
    valid: true,
    ID: null,
    BranchInfo: {
      BranchName: "",
      BranchPhone: "",
      BranchAdmin: "",
    },
    existingInfo: {
      BranchName: false,
      UserName: false,
    },
    showPassword: false,
    NameIcon: null,
    UserIcon: null,
  }),
  watch: {
    dialog(v) {
      if (v) {
        // console.log(this.Branch);
        this.BranchInfo = {
          BranchName: this.Branch.BranchName,
          BranchPhone: this.Branch.BranchPhone,
          BranchAdmin: this.Branch.BranchAdmin,
        };
      }
    },
  },
  methods: {
    checkBranchName(v) {
      if (this.existingInfo.BranchName) {
        this.existingInfo.BranchName = false;
        this.NameIcon = "fas fa-times";
        return `${v} is already taken`;
      } else {
        this.NameIcon = "fas fa-check";
        return true;
      }
    },

    OnSaveBranch() {
      if (this.$refs.BranchForm.validate()) {
        this.clicked = true;
        this.msgError = "";
        this.$store
          .dispatch("UPDATE_ONLY", {
            url: "/branches",
            data: { ...this.BranchInfo, ID: this.ID },
          })
          .then(() => {
            // console.log(result);
            this.clicked = false;
            this.resetValidation();
            this.$store.dispatch("loadBaraches", true);
            this.dialog = false;
          })
          .catch(err => {
            this.clicked = false;
            if (err.response.status === 409) {
              console.log(err.response.data);
              this.existingInfo.BranchName = err.response.data.BranchName;
              this.$refs.BranchForm.validate();
            } else {
              this.msgError = err.response.data;
            }
          });

        // console.log(this.CompanyInfo);
        // this.reset();
      }
    },

    resetValidation() {
      this.$refs.BranchForm.resetValidation();
    },
  },
  created() {
    this.ID = this.Branch._id;
    // this.BranchInfo = {
    //   BranchName: this.Branch.BranchName,
    //   BranchPhone: this.Branch.BranchPhone,
    //   BranchAdmin: this.Branch.BranchAdmin
    // };
  },
};
</script>
